module.exports = __webpack_public_path__ + "static/media/image22.7f6ba55f.JPG";